import groq from 'groq';
import { ImageComponentFragment } from '../components/image';
import { TextComponentFragment } from '../components/text';
import { VideoComponentFragment, MediaComponentFragment } from '../components/media';
import { QuoteComponentFragment } from '../components/quote';
import { IconStackComponentFragment } from '../components/iconStack';
import { CarouselFragment } from '../components/carousel';
import { AccordionItemComponentFragment } from '../components/accordion';
import { ModalLayoutFragment } from '../components';
import { ComponentType } from '$lib/sanity/types';

export const TextComponentResolver = groq`
  _type == "${ComponentType.Text}" => {
    ${TextComponentFragment}
  }
`;

export const ImageComponentResolver = groq`
  _type == "${ComponentType.Image}" => {
    ${ImageComponentFragment}
  }
`;

export const VideoComponentResolver = groq`
  _type == "${ComponentType.Video}" => {
    ...,
    ${VideoComponentFragment}
  }
`;

export const MediaComponentResolver = groq`
  _type == "${ComponentType.Media}" => {
    ${MediaComponentFragment}
  }
`;

export const QuoteComponentResolver = groq`
  _type == "${ComponentType.Quote}" => {
    ${QuoteComponentFragment}
  }
`;

export const IconStackComponentResolver = groq`
  _type == "${ComponentType.IconStack}" => {
    ${IconStackComponentFragment}
  }
`;

export const CarouselComponentResolver = groq`
  _type == "${ComponentType.Carousel}" => {
    ${CarouselFragment}
  }
`;

export const AccordionComponentResolver = groq`
  _type == "${ComponentType.Accordion}" => {
    ...,
    items[]-> {
      ${AccordionItemComponentFragment}
    }
  }
`;

export const ModalComponentResolver = groq`
  _type == "${ComponentType.Modal}" => {
    ...,
    ${ModalLayoutFragment}
  }
`;
